$(function() {
  	$(window).on('load scroll', function() {
		var scrollPos = $(this).scrollTop();
      if ( scrollPos > 140 ) {
      $('header').addClass('header_shrink');
    } else {
      $('header').removeClass('header_shrink');
    }
  });
  // ハンバーガーメニューCATEGORY・スポーツ検索の開閉
    $(".cate_first").on('click', function() {//cate_firstクラスをクリックしたら
    var parentElem =  $(this).parent();// aタグから見た親要素を取得し
    $(parentElem).toggleClass('active');//矢印方向を変えるためのクラス名を付与して
    $(parentElem).children('div').stop().slideToggle(500);//liの子要素のスライドを開閉させる※数字が大きくなるほどゆっくり開く
    return false;//リンクの無効化
  });
      $(".sports_first").on('click', function() {//cate_firstクラスをクリックしたら
    var parentElem =  $(this).parent();// aタグから見た親要素を取得し
    $(parentElem).toggleClass('active');//矢印方向を変えるためのクラス名を付与して
    $(parentElem).children('div').stop().slideToggle(500);//liの子要素のスライドを開閉させる※数字が大きくなるほどゆっくり開く
    return false;//リンクの無効化
  });
});	